import { SimpleGrid } from "@chakra-ui/react";
import React from "react";
import { Field, Form } from "react-final-form";
import { PRODUCT_CATEGORIES, UNITS } from "../../../../utils/constants";
import CategoriesField from "../../../fields/CategoriesField";
import CheckboxField from "../../../fields/CheckboxField";
import FileUploadField from "../../../fields/FileUploadField";
import InputField from "../../../fields/InputField";
import MeasurementUnitField from "../../../fields/MeasurementUnitField";
import NumberField from "../../../fields/NumberField";
import SelectField from "../../../fields/SelectField";
import { updateValidator as validate } from "./validators";

type Props = {
  onSubmit: (...params: any) => void;
  formName?: string;
  initialValues?: any;
  retailOnly?: boolean;
  wholeSaleOnly?: boolean;
  priceOnly?: boolean;
};

const UpdateCommodityForm = (props: Props) => {
  const {
    onSubmit,
    formName,
    initialValues,
    retailOnly,
    wholeSaleOnly,
    priceOnly,
  } = props;
  let UI = (
    <>
      <Field name="name" label="Name" component={InputField} />
      <Field
        name="measurementUnit"
        label="Measurement Unit"
        component={MeasurementUnitField}
        options={UNITS}
        menuPortalTarget={document.body}
      />

      <Field
        name="categories"
        label="Categories"
        component={CategoriesField}
        options={PRODUCT_CATEGORIES}
        menuPortalTarget={document.body}
      />
      <Field
        name="status"
        label="Status"
        component={SelectField}
        options={[
          {
            label: "Active",
            value: "active",
          },
          {
            label: "Archived",
            value: "archived",
          },
        ]}
        menuPortalTarget={document.body}
      />
      <Field
        name="retail"
        label="Retail Price"
        min={1}
        component={NumberField}
      />
      <Field
        name="wholeSale"
        label="Whole Sale Price"
        min={0}
        component={NumberField}
      />
    </>
  );

  if (retailOnly) {
    UI = (
      <Field
        name="retail"
        label="Retail Price"
        min={1}
        component={NumberField}
      />
    );
  }

  if (wholeSaleOnly) {
    UI = (
      <Field
        name="wholeSale"
        label="Whole Sale Price"
        min={0}
        component={NumberField}
      />
    );
  }
  return (
    <Form
      onSubmit={onSubmit}
      validate={validate}
      initialValues={initialValues}
      mutators={{
        setFile: ([args], state, { changeValue }) => {
          console.log({
            args,
            state,
            changeValue,
          });
          changeValue(state, "file", () => args);
        },
      }}
    >
      {(props) => (
        <form onSubmit={props.handleSubmit} id={formName}>
          <SimpleGrid columns={[1, 1]} spacing={5} p="10">
            {UI}

            <Field
              name="isNewPrice"
              label="Set as new price"
              component={CheckboxField}
              type="checkbox"
            />

            {!priceOnly && (
              <FileUploadField
                isUpdate={true}
                img={initialValues.imageURL}
                setFile={props.form.mutators.setFile}
              />
            )}

            {/* 
                <Image boxSize="100px" src={initialValues.imageURL} m="1" /> */}

            {/* <Field
                name="note"
                label="Note"
                component={InputField}
              defaultChecked
            /> */}
          </SimpleGrid>
        </form>
      )}
    </Form>
  );
};

export default UpdateCommodityForm;
